// Utility to handle WebP image optimization
export const getOptimizedImageSrc = (imagePath) => {
    // Remove any leading slash for consistency
    const normalizedPath = imagePath.replace(/^\//, '');
    const pathWithoutExt = normalizedPath.replace(/\.[^/.]+$/, '');
    const webpPath = `${pathWithoutExt}.webp`;

    // List of available WebP images in your project (with leading slash)
    const availableWebPImages = [
        '/Images/logo-new.webp',
        '/Images/playStore.webp',
        '/Images/karim1.webp',
        '/Images/Alisa.webp',
        '/Images/unique.webp',
        '/Images/iphone.webp',
        '/Images/iphone2.webp',
        '/Images/iphone3.webp',
        '/Images/faqMobileBg.webp',
        '/Images/mobile_hero_bg.webp',
        '/Images/heroBanner.webp',
        '/Images/heroImgWebp.webp',
        '/Images/LeftWebp.webp',
        '/Images/RightWebp.webp',
        '/Images/AlisaNEUWebp.webp',
        '/Images/TeamMemeberMen1Webp.webp',
        // Blog images
        '/Images/blog1.1.webp',
        '/Images/blog1.2.webp',
        '/Images/blog2.1.webp',
        '/Images/blog2.2.webp',
        '/Images/blog3.1.webp',
        '/Images/blog3.2.webp',
        '/Images/blog4.1.webp',
        '/Images/blog4.2.webp',
        '/Images/blog5.1.webp',
        '/Images/blog5.2.webp'
    ];

    // Check if WebP version exists in our list
    const hasWebP = availableWebPImages.includes('/' + webpPath);

    if (hasWebP) {
        // Check browser support for WebP
        const supportsWebP = () => {
            const canvas = document.createElement('canvas');
            canvas.width = 1;
            canvas.height = 1;
            return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        };

        // If browser supports WebP, return WebP path
        if (supportsWebP()) {
            return '/' + webpPath;
        } else {
        }
    } else {
    }

    // Fallback to original image (with leading slash)
    return '/' + normalizedPath;
};

// Helper to generate srcSet for responsive images
export const getResponsiveSrcSet = (src, widths = [400, 800]) => {
    // src: '/Images/iphone2.webp' => '/Images/iphone2-400.webp 400w, /Images/iphone2-800.webp 800w'
    const ext = src.substring(src.lastIndexOf('.'));
    const base = src.substring(0, src.lastIndexOf('.'));
    return widths.map(w => `${base}-${w}${ext} ${w}w`).join(', ');
};

// Component to handle optimized images with responsive sizes and srcSet
export const OptimizedImage = ({ src, alt, className, sizes = "100vw", srcSet, ...props }) => {
    const optimizedSrc = getOptimizedImageSrc(src);
    const isWebP = optimizedSrc.endsWith('.webp');
    // If srcSet is not provided, try to auto-generate for known images
    let finalSrcSet = srcSet;
    if (!srcSet && /(iphone2|iphone|banner1|support2|blog\d+\.?\d*)/.test(src)) {
        finalSrcSet = getResponsiveSrcSet(src);
    }
    return (
        <img
            src={optimizedSrc}
            alt={alt}
            className={`${className || ''} ${isWebP ? 'webp-optimized' : 'original-format'}`}
            loading="lazy"
            sizes={sizes}
            srcSet={finalSrcSet}
            {...props}
        />
    );
};

// Function to preload critical WebP images
export const preloadCriticalImages = () => {
    const criticalImages = [
        '/Images/logo-new.webp',
        '/Images/heroImgWebp.webp',
        '/Images/heroBanner.webp'
    ];

    criticalImages.forEach(imagePath => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = imagePath;
        document.head.appendChild(link);
    });
};

// Function to get responsive image sizes for different screen sizes
export const getResponsiveImageSizes = (type = 'blog') => {
    switch (type) {
        case 'blog-thumbnail':
            return '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw';
        case 'blog-detail':
            return '(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 60vw';
        default:
            return '100vw';
    }
}; 